export default {
  user: null,
  userName: '',
  collapse: false,
  sendingInvite: false,
}